module.exports = __webpack_public_path__ + "static/media/6c73e461-9dee-4e61-bb90-7e42bbb5d81f.dc6621df.jpg";